import PropTypes from 'prop-types';
import { BsStars, BsArrowRight } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';

/**
 * Dashboard re-entry point for the first-run strategy assistant. Users who
 * dismissed the onboarding modal (accidentally or on purpose) can restart it
 * here — otherwise the flow would be unreachable forever.
 */
const StrategyAssistantCard = ({ onStart }) => (
	<Card className="border-primary-200 bg-primary-100">
		<div className="flex flex-col sm:flex-row sm:items-center gap-4">
			<div className="h-10 w-10 rounded-control bg-white text-primary-600 flex items-center justify-center flex-shrink-0">
				<BsStars className="w-5 h-5" />
			</div>
			<div className="flex-1 min-w-0">
				<h2 className="text-md font-semibold text-text">KI-Strategie-Assistent</h2>
				<p className="text-sm text-bgBase-800">
					Vertriebsstrategie + erste passende Leads in 2 Minuten — kostenlos.
				</p>
			</div>
			<Button variant="solid" onClick={onStart} className="shrink-0">
				Jetzt starten
				<BsArrowRight className="w-4 h-4 ml-2" />
			</Button>
		</div>
	</Card>
);

StrategyAssistantCard.propTypes = {
	onStart: PropTypes.func.isRequired,
};

export default StrategyAssistantCard;
